import { useTranslation } from 'react-i18next'

import { disconnectRequestDocFlows } from '../../../../api'
import { EMPTY_FUNCTION } from '../../../../constants/common'
import { useNotification } from '../../../../hooks'
import { getRequestDocFlowsPayload } from '../../../../utils/docFlow'
import { ConfirmationModal } from '../../../Confirmation'

export function useRequestDisconnectDocFlows({ onCloseModal, onSetModal }) {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  function handleOpenDisconnectDocFlows({
    docFlowIds,
    requestId,
    onSettled = EMPTY_FUNCTION,
    onStart = EMPTY_FUNCTION,
    onSuccess,
  }) {
    function handleSubmitDisconnect() {
      onCloseModal()

      onStart()

      disconnectRequestDocFlows({
        data: getRequestDocFlowsPayload(docFlowIds),
        id: requestId,
      })
        .then(() => {
          handleAddSuccessNotification({
            title: t('Notification.RequestTitleDocFlowsDisconnectedKey', {
              count: docFlowIds.length,
            }),
          })

          onSuccess()
        })
        .catch(() => {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        })
        .finally(onSettled)
    }

    onSetModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitText: t('Modal.DisconnectDocFlowsBtnKey'),
        }}
        description={t('Modal.DisconnectDocFlowsAttentionMessageKey', {
          count: docFlowIds.length,
        })}
        title={t('Modal.DisconnectDocFlowsTitleKey', {
          count: docFlowIds.length,
        })}
        onCancel={onCloseModal}
        onSubmit={handleSubmitDisconnect}
      />
    )
  }

  return { handleOpenDisconnectDocFlows }
}
